// extracted by mini-css-extract-plugin
module.exports = {"section":"I_section__vjRoJ","scrollLeft":"I_scrollLeft__J44Fb"};